import React from 'react';
import { Button, Form } from 'react-bootstrap';
import ToggleWithLabel from './../../components/ToggleWithLabel/ToggleWithLabel'
import styles from './PropertyRpmSettings.module.css'
import { useIntl } from 'react-intl';

export default function PropertyRpmSettings({ onSavePropertySettings, propertySettings, setPropertySettings, isSaving }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const updateField = ({ target: { type, value, checked } }, base, field) => {
    base[field] = type === 'checkbox' ? checked : value;
    setPropertySettings({ ...propertySettings });
  }


  if (!propertySettings) return null;

  return (
    <div className={styles.propertyRpmSettings}>
      <Form key="field_visibility_form" className="is-common-form">
        <div className={`${styles.saveButton} row my-sm-4 d-flex align-items-center`}>
          <div className="font-lg col-sm-8" style={{ lineHeight: '60px' }}>{t('PropertyRpmSettings.description')}</div>
          <div className="pl-5 col-sm-4" align="right">
            <Button disabled={isSaving} onClick={() => onSavePropertySettings({ ...propertySettings }, 'gridEnabled')} >{t('PropertyRpmSettings.save')}</Button>
          </div>
          <div className="col-sm-12 mt-3 mt-sm-5">
            <ToggleWithLabel 
              titleLabel={t('PropertyRpmSettings.gridEnabled.label')} 
              titleDescriptions={[t('PropertyRpmSettings.gridEnabled.desc')]} 
              ids={['gridEnabled']}
              getObject={propertySettings}
              getKeys={['gridEnabled']}
              updateFunction={updateField} 
            />
          </div>
        </div>
      </Form>
    </div>
  )
}
